module.exports = "https://static.wanderu.com/ui-react/_next/static/media/es.039cad8d.svg";